"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { WindowDragStrip } from "@/components/electron/window-drag-strip";

export default function Home() {
  const router = useRouter();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    fetch("/api/auth/session", { cache: "no-store" })
      .then((res) => res.json())
      .then((data) => {
        if (data.authenticated) {
          router.replace("/app");
        } else {
          router.replace("/login");
        }
      })
      .catch(() => {
        router.replace("/login");
      })
      .finally(() => setChecking(false));
  }, [router]);

  // Usually a few hundred ms before redirecting: the bare app canvas, no
  // spinner, so the colour doesn't jump from white to the app's grey.
  if (checking) {
    return (
      <div className="h-screen bg-sidebar">
        <WindowDragStrip />
      </div>
    );
  }

  return null;
}
